import { baseApi } from '@/lib/utils'

export interface ExpenseRatioHistoryItem {
  id: number
  expense_ratio: string | number
  start_date: string | null
  end_date: string | null
  created_at: string | null
  updated_at?: string | null
}

export interface ExpenseRatioHistoryResponse {
  message?: string
  status?: string
  data: ExpenseRatioHistoryItem[]
}

export interface UpsertExpenseRatioPayload {
  expense_ratio: number
  start_date: string
  end_date: string | null
}

export interface UpdateExpenseRatioPayload {
  id: number
  data: Partial<UpsertExpenseRatioPayload>
}

const expenseRatioMutationInvalidates = [
  { type: 'ExpenseRatioHistory' as const, id: 'LIST' },
  'ProjectPage' as const,
]

export const expenseRatioHistoryApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    getExpenseRatioHistory: builder.query<ExpenseRatioHistoryResponse, void>({
      query: () => ({
        url: '/expense-ratio-history',
      }),
      providesTags: [{ type: 'ExpenseRatioHistory', id: 'LIST' }],
    }),
    createExpenseRatioHistory: builder.mutation<
      { message: string; data?: ExpenseRatioHistoryItem },
      UpsertExpenseRatioPayload
    >({
      query: body => ({
        url: '/expense-ratio-history',
        method: 'POST',
        body,
      }),
      invalidatesTags: expenseRatioMutationInvalidates,
    }),
    updateExpenseRatioHistory: builder.mutation<
      { message: string; data?: ExpenseRatioHistoryItem },
      UpdateExpenseRatioPayload
    >({
      query: ({ id, data }) => ({
        url: `/expense-ratio-history/${id}`,
        method: 'PATCH',
        body: data,
      }),
      invalidatesTags: expenseRatioMutationInvalidates,
    }),
    deleteExpenseRatioHistory: builder.mutation<
      { message: string },
      { id: number }
    >({
      query: ({ id }) => ({
        url: `/expense-ratio-history/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: expenseRatioMutationInvalidates,
    }),
  }),
})

export const {
  useGetExpenseRatioHistoryQuery,
  useCreateExpenseRatioHistoryMutation,
  useUpdateExpenseRatioHistoryMutation,
  useDeleteExpenseRatioHistoryMutation,
} = expenseRatioHistoryApi
